

import React, { createContext, useReducer } from 'react';

import _get from 'lodash.get';

import { ActionTypes, ModuleType } from '../types';








const store = createContext({});
const { Provider } = store;

const _updateModules = ({ modules, moduleId, data }) => modules.map((module) => {
  if (module.uuid === moduleId) {
    const { moduleDescriptorValueToSet, overrides } = data;
    return {
      ...module,
      descriptor: {
        ...module.descriptor,
        ...moduleDescriptorValueToSet
      },
      ...overrides
    };
  }

  return module;
});


const _updateColumns = ({ columns, columnId, moduleId, data }) => columns.map((column) => {
  if (column.uuid === columnId) {
    return {
      ...column,
      modules: _updateModules({
        modules: column.modules,
        moduleId,
        data
      })
    };
  }

  return column;
});

const TemplateProvider = ({ children }) => {
  const [templateState, dispatch] = useReducer((state, action) => {
    const { type, payload } = action;

    switch (type) {
      case ActionTypes.INSERT:{
          return {
            ...payload
          };
        }

      case ActionTypes.UPDATE_BLOCK:{
          const { rowId, moduleId, columnId, data } = payload;
          const rows = _get(state, 'page.rows', []);

          const updatedRows = rows.map((row) => {
            if (row.uuid === rowId) {
              return {
                ...row,
                columns: _updateColumns({
                  columns: row.columns,
                  columnId,
                  moduleId,
                  data
                })
              };
            }

            return row;
          });

          return {
            ...state,
            page: {
              ...state.page,
              rows: updatedRows
            }
          };
        }

      case ActionTypes.UPDATE_ROW:{
          const { rowId, data } = payload;
          const rows = _get(state, 'page.rows', []);

          const updatedRows = rows.map((row) => {
            if (row.uuid === rowId) {
              return {
                ...row,
                ...data
              };
            }

            return row;
          });

          return {
            ...state,
            page: {
              ...state.page,
              rows: updatedRows
            }
          };
        }

      case ActionTypes.DELETE_ROW_VIDEO:{
          const { rowId } = payload;
          const rows = _get(state, 'page.rows', []);

          const updatedRows = rows.map((row) => {
            if (row.uuid === rowId) {
              return {
                ...row,
                columns: row.columns.map((column) => ({
                  ...column,
                  modules: [
                  ...column.modules.filter((module) => module.type !== ModuleType.VIDEO)]

                }))
              };
            }

            return row;
          });

          return {
            ...state,
            page: {
              ...state.page,
              rows: updatedRows
            }
          };
        }

      case ActionTypes.UPDATE_ROW_VIDEO:{
          const { rowId, data } = payload;
          const rows = _get(state, 'page.rows', []);

          const updatedRows = rows.map((row) => {
            if (row.uuid === rowId) {
              return {
                ...row,
                columns: row.columns.map((column) => ({
                  ...column,
                  modules: [
                  ...data,
                  ...column.modules.filter((module) => module.type !== ModuleType.VIDEO)]

                }))
              };
            }

            return row;
          });

          return {
            ...state,
            page: {
              ...state.page,
              rows: updatedRows
            }
          };
        }

      default:{
          return state;
        }
    }
  }, {});

  return (
    <Provider value={{ state: templateState, dispatch }}>
      {children}
    </Provider>);

};

export { store, TemplateProvider };